import { useLingui } from "@lingui/react";
import { BrandFilter, Filter, Range } from "src/molecules/Filter";
import { PRICE_FACET } from "src/utils/algolia";
import { FiltersWrapper } from "./Facets.styled";
import { availableFiltersList } from "src/organisms/AlgoliaProductList/availableFilters";
import { FilterType } from "src/organisms/MobileFilters";
import { useStats } from "react-instantsearch-core-v7";

type filtersProps = {
  excludeFilters: string[];
  handleScrollToTop: () => void;
};

function Filters({
  excludeFilters,
  handleScrollToTop,
}: filtersProps): JSX.Element {
  const { _ } = useLingui();
  const { nbHits } = useStats();

  return (
    <FiltersWrapper>
      {availableFiltersList
        .filter(({ facet }) => !excludeFilters.includes(facet))
        .map(({ type, facet, name, isMultiColumn }) => {
          if ((type as FilterType) === "brands") {
            return (
              <BrandFilter
                key={facet}
                attribute={facet}
                placeholder={_(name)}
                type="multi-select"
                totalResults={nbHits}
                searchPlaceholder={_({ id: "Search brand" })}
                showSearch={true}
                handleScrollToTop={handleScrollToTop}
              />
            );
          }

          if ((type as FilterType) === "range") {
            return (
              <Range
                key={facet}
                attribute={PRICE_FACET}
                totalResults={nbHits}
                placeholder={_(name)}
                handleScrollToTop={handleScrollToTop}
              />
            );
          }

          return (
            <Filter
              key={facet}
              attribute={facet}
              placeholder={_(name)}
              type={type as FilterType}
              totalResults={nbHits}
              isMultiColumn={isMultiColumn}
              handleScrollToTop={handleScrollToTop}
            />
          );
        })}
    </FiltersWrapper>
  );
}

export { Filters };
